import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {newsletterTemplateColorsList_template} from "../components/templates/newsletterTemplateColorsList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class newsletter_template_colors extends vnModule_knockoutJS {

    protected XHRHdl!: XMLHttpRequestHandler;
    protected newsletterTemplateColorsList!: newsletterTemplateColorsList_template;
    protected pagination!: pagination_template;

    buildContent(): Array<Element> {
        this.newsletterTemplateColorsList = new newsletterTemplateColorsList_template("newsletterTemplateColorsList", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader!.loadedModule;
        (<header>loadedModule).setHeaderTitle("Newsletter Header Colors");
        return [this.newsletterTemplateColorsList.build()];
    }

    protected getModuleName(): string {

        return "newsletter_template_colors";
    }

    fillPage() {

        this.getColorsListData();
    }

    protected getColorsListData() {

        this.loadingIn(this.newsletterTemplateColorsList.builtTemplate.children.namedItem("list-results")!);
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.newsletterTemplateColorsList.getViewModelForRequest())]);

        let url: string = '/api/brand/' + idBrand + "/newsletter/templates/colors/get/";

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetColorsListDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetColorsListDataReturn(req: any, obj: any) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let totalCount = responseParsed.totalCount
                let totalPage = responseParsed.totalPage
                let colors = responseParsed.data;

                obj.viewModel.newsletterTemplateColorsList.pagination.itemCount(totalCount);

                let execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100

                obj.newsletterTemplateColorsList.setResultInfo(totalCount, totalPage, execTime)
                obj.newsletterTemplateColorsList.setColors(colors)

            });
            obj.loadingOut(obj.newsletterTemplateColorsList.builtTemplate.children.namedItem("list-results")!);
        }
    }

    protected colorsListReorder() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.getColorsListData()
    }

    protected paginationOnPageClick() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.getColorsListData();
    }

    protected filterSimpleOnChange(){

        this.viewModel.newsletterTemplateColorsList.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.newsletterTemplateColorsList.builtTemplate.children.namedItem("list-results")!);

        let colorsReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/colors/get/';
        let colorsReq_params: Array<Array<string>> = [];
        colorsReq_params.push(["data", ko.toJSON(this.newsletterTemplateColorsList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(colorsReq_url, colorsReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req: any, obj: any){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.newsletterTemplateColorsList.setColors(responseParsed.data);

                let execTime = Math.round((new Date().getTime() - obj.XHRHdl.requestStartTime)/1000*100)/100;
                obj.newsletterTemplateColorsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

                obj.viewModel.newsletterTemplateColorsList.pagination.itemCount(responseParsed.totalCount);
            });
            obj.loadingOut(obj.newsletterTemplateColorsList.builtTemplate.children.namedItem("list-results")!);
        }
    }

    protected cancel() {

        page.redirect('/brand/' + this.getVnAppZone().app.params.idBrand + "/newsletter/templates/")
    }

    protected add() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/colors/add/')
    }

    protected edit(id: any) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/templates/colors/edit/' + id + '/')
    }

    protected delete(data: any) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url = "/api/brand/" + idBrand + "/newsletter/templates/colors/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.newsletterTemplateColorsList.builtTemplate.children.namedItem("list-results")!);
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req: any, obj: any) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "Header Color " + "<strong>" + data.name + "</strong>" + " was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule()
                    obj.getColorsListData()
                })

                obj.loadingOut(obj.newsletterTemplateColorsList.builtTemplate.children.namedItem("list-results")!);
            }
        });
        XHRHdl.execute();
    }
}



// WEBPACK FOOTER //
// ./js/modules/newsletter_template_colors.ts